const cache = new Map();

export async function getConsentPolicyByClientId (clientId) {
    const CONSENTS = {
        TERMS: 'https://loginstatic.pearson.com/html/PearsonEULA.html',
        PRIVACY_POLICY: 'https://loginstatic.pearson.com/html/PearsonPrivacyPolicy.html'
    };

    if (!clientId) {
        console.log('no client id passed.');
        return CONSENTS;
    };

    if (cache.has(clientId)) {
        return cache.get(clientId);
    }

    const CATEGORY_MAPPING = {
        'terms of use': 'TERMS',
        'privacy policy': 'PRIVACY_POLICY'
    };

    try {
        const headers = new Headers();
        headers.append('x-openidm-username', 'anonymous');
        headers.append('x-openidm-password', 'anonymous');

        const response = await fetch(
            `/openidm/endpoint/consentpolicy?action=get&clientID=${clientId}`,
            {
                method: 'GET',
                headers: headers
            }
        );

        if (!response.ok) {
            return CONSENTS;
        };

        const data = await response.json();

        for (const policy of data.policyDetails) {
            const category = policy.category.toLowerCase();
            if (category in CATEGORY_MAPPING) {
                CONSENTS[CATEGORY_MAPPING[category]] = policy.policyRef;
            };
        };
        cache.set(clientId, CONSENTS);
        return CONSENTS;
    } catch (error) {
        console.log(error);
        return CONSENTS;
    }
};
